module.exports = __webpack_public_path__ + "static/media/horse-modal.849b0c5d.gif";